import React, { useState, useEffect } from 'react';
import '../App.css';
import axios from "axios";
import { ListGroup, Row, Col } from 'react-bootstrap';
//import Navbar from "./Navbar_vecchio";
//import Nuovo_Alunno_Edit from "./Alunno_x0_Edit";
//import DatePicker from "react-datepicker";
//import Crea_nuovo_alunno from "./Alunno_x0_1_crea_alunno";
import { useAuth0 } from "@auth0/auth0-react";
import JSONPretty from 'react-json-pretty';
//import Dropdown_Classi from "./Classe_x2_assegna_tutor";
import Nuovo_Tutor_Edit from "./Tutor_x0_Edit";
import Trova_classi_assegnate_al_tutor from "./Tutor_trova_classi.jsx";
//const { Controlla_se_lavoro_in_debug } = require('../Funzioni_comuni')



function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
  }



  function Controlla_se_lavoro_in_debug (user) {
    let debug = false
    let email_google = check_variabili_oggetto (user, 'email')  
      
        if (email_google === 'p.sordi@ipsiapacinotti.it' || 
            email_google === 'g.falcitelli@ipsiapacinotti.it' ||
            email_google === 'dirigente@ipsiapacinotti.it' ||
            email_google === 't.fogli@ipsiapacinotti.it') {
        }
        if (email_google === 'paolosordi12@gmail.com' ||
            email_google === 'dirigente@ipsiapacinotti.it' ||
            email_google === 't.fogli@ipsiapacinotti.it') {
              debug=true
        }
    
        return debug
    }  

const Gestione_Tutor = (props) => {
    const [input, setInput] = useState({
        nome: '',
        cognome: '',
        email: '',
        email_genitore: ''

    });
    const [lista_tutor, SET_lista_tutor] = useState([]);
    const [variab_aggiorna, SET_variab_aggiorna] = useState(false);
    const [end_Date, set_End_Date] = useState(new Date());
    const { user, isAuthenticated } = useAuth0();
    const [lista_classi, SET_lista_classi] = useState([]);
  

    useEffect(() => {

        let email_google = check_variabili_oggetto (user, 'email')  
        console.log(check_variabili_oggetto (user, 'email'))
        if (Controlla_se_lavoro_in_debug) {Carica_tutor_x_account()}
      
  
    }, [variab_aggiorna, user]);



    const Carica_tutor_x_account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('Carica_tutor_x_account')
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}

        axios.get('/tutor/tutor_carica_tutti/' + utente)
            .then((res) => {
                console.log('TUTOR appena fecciate da mongo')
                console.log(res.data)
                SET_lista_tutor(res.data)
            }).catch((error) => {
                console.log(error)
            });
    }


    function handleChange(event) {
        const { name, value } = event.target;

        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }


    function handleClick(event) {
        event.preventDefault();
        const nuovo_tutor = {
            nome: input.nome,
            cognome: input.cognome,

            email: input.email
        }

        axios.post('/tutor/salva_nuovo', nuovo_tutor)
        .then((res) => {
            //                console.log('Aggiunta una classe')
            SET_variab_aggiorna(current => !current)
         }).catch((error) => {
            console.log('Cancella')

        });
    }


    function Cancella(id1,id2) {
        console.log('Cancella')
        console.log(id1)
        console.log(id2)
        
        SET_variab_aggiorna(current => !current)
        axios.put('/tutor/togli_classe_al_tutor/' + id1 + '/' + id2) 
            .then((res) => {
            //                console.log('Aggiunta una classe')
            console.log(res.data)
        }).catch((error) => {
            console.log(error)
        });
    }



    return (
        <div className='container'>
            
            {(props.account_dati.utente_debug) &&
        
                <JSONPretty data={user} />
            }
            <div className='container'>
                <h1>Inserisci nuovo tutor </h1>
                <form>
                    <div className='form-group'>
                        <input onChange={handleChange} name="nome" placeholder="nome" value={input.nome} autoComplete="off" className="form-control"></input>
                    </div>
                    <div className='form-group'>
                        <input onChange={handleChange} name="cognome" placeholder="cognome" value={input.cognome} autoComplete="off" className="form-control"></input>
                    </div>
                    <div className='form-group'>
                        <input onChange={handleChange} name="email" placeholder="email" value={input.email} autoComplete="off" className="form-control"></input>
                    </div>

                    <div class="d-flex flex-row-reverse">
                        <button onClick={handleClick} className="btn btn-lg btn-info">Salva</button>
                    </div>
                </form>
            </div>



            <div className='container'>

                <ListGroup>
                    {lista_tutor.map(function (item, index2) {
                        {
                            //                        console.log(item)
                            return <div>
                                <Row>
                                    <Nuovo_Tutor_Edit tutor={item} variab_aggiorna={variab_aggiorna} SET_variab_aggiorna={SET_variab_aggiorna} />
                                    <Col>
                                    <ul>
                                        <li><strong>{item.cognome} &nbsp; {item.nome}</strong></li>
                                        <li>Email: <strong>{item.email}</strong></li>
                                        <li>Cell: <strong>{item.cellulare}</strong></li>
                                        
                                        </ul>
                                    </Col>
                                    <Col>
                                        <Trova_classi_assegnate_al_tutor tutor={item}/> 
                                    </Col>
                                    {(props.account_dati.utente_debug) &&
        
                                        <JSONPretty data={item} />
                                    }
                                </Row>
                                <hr class="rounded"></hr>

                            </div>
                        }
                    })
                    }
                </ListGroup>
            </div>
        </div >
    )
}

export default Gestione_Tutor;
